import request from '../config/axiosConfig';
import { CHANGE_CAMPAIGN_STATUS, CREATE_UPDATE_CAMPAIGN, DELETE_CAMPAIGN, GET_CAMPAIGN_DETAIL, GET_LIST_CAMPAIGNS, GET_LIST_PROVINCES } from '../constants/apiEndPoint';

export const getListCampaignsRequest = async (data) => {
  const result = await request({
    url: GET_LIST_CAMPAIGNS,
    method: 'POST',
    data,
  });
  return result?.data?.data;
};

export const getCampaignInfoRequest = async (data) => {
  const result = await request({
    url: GET_CAMPAIGN_DETAIL,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

export const createUpdateCampaignRequest = async (data) => {
  const result = await request({
    url: CREATE_UPDATE_CAMPAIGN,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteCampaignRequest = async (data) => {
  const result = await request({
    url: DELETE_CAMPAIGN,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const changeCampaignStatusRequest = async (data) => {
  const result = await request({
    url: CHANGE_CAMPAIGN_STATUS,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const getListProvincesRequest = async (data) => {
  const result = await request({
    url: GET_LIST_PROVINCES,
    method: 'POST',
    data,
  });
  return result?.data?.data?.data;
};

